import { useTranslate } from '@tolgee/react'
import { TomAutoComplete, TomAutoCompleteProps } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'

type Props<M extends boolean = false> = {
  options: string[]
  onChange: (permissions: M extends true ? string[] : string) => void
} & TomAutoCompleteProps<string, M>

export const PermissionsAutoComplete = observer(<M extends boolean = false>(props: Props<M>) => {
  const { t } = useTranslate()
  const { dataCy, defaultValue, label, onChange, options } = props

  return (
    <TomAutoComplete
      {...props}
      dataCy={dataCy ?? 'permissions-autocomplete'}
      label={label ?? t('permissions', 'Permissions')}
      options={options}
      defaultValue={defaultValue}
      enablePortal
      placeholder={t('selectPermissions', 'Select permissions')}
      onChangeEntity={entity => {
        onChange(entity as M extends true ? string[] : string)
      }}
    />
  )
})
